import { render } from "./TableroControlActivos.vue?vue&type=template&id=eff0d0c8&scoped=true"
import script from "./TableroControlActivos.vue?vue&type=script&lang=js"
export * from "./TableroControlActivos.vue?vue&type=script&lang=js"

import "./TableroControlActivos.vue?vue&type=style&index=0&id=eff0d0c8&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eff0d0c8"]])

export default __exports__